import React, { createContext, useContext, useState } from "react";
import { API_URL } from "../utils/apiUrl";

export const TOKEN_KEY = "qrt_token";
export const USER_KEY = "qrt_user";

// A SUPERADMIN sees every QR code and manages the accounts; a USER sees only
// their own codes (the API enforces it)
export const SUPERADMIN = "SUPERADMIN";
export const isSuperAdmin = (user) => user?.role === SUPERADMIN;

const AuthContext = createContext(null);

// Lets non-React code (the api client) trigger logout
let externalLogout = null;

// Plain fetch, not the api client: a 401 here must not re-trigger forceLogout
function notifyLogout() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return;
  fetch(`${API_URL}/logout`, {
    method: "POST",
    headers: { Token: token },
    keepalive: true,
  }).catch(() => {});
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY)) || null;
    } catch {
      return null;
    }
  });

  function login(token, userData) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    setUser(userData);
  }

  function logout() {
    notifyLogout();
    setUser(null);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
  }

  externalLogout = logout;

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function forceLogout() {
  if (externalLogout) {
    externalLogout();
  }
  window.location.href = "/login";
}
